import { render, staticRenderFns } from "./step-tech-modification.vue?vue&type=template&id=4db0bebf"
import script from "./step-tech-modification.vue?vue&type=script&lang=ts"
export * from "./step-tech-modification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports